import { useCallback, useState } from 'react';
import { activateUsuario, deactivateUsuario, UsuarioToggle } from '../services/usuarioService';
import { dispatchGlobalError } from '../context/ApiErrorContext';

export type ToggleFn = (id: string, targetAtivo: boolean) => Promise<UsuarioToggle>;

export function useToggleUsuarioAtivo() {
  const [loadingById, setLoadingById] = useState<Record<string, boolean>>({});

  const setLoading = (id: string, value: boolean) =>
    setLoadingById((prev) => (value ? { ...prev, [id]: true } : ((): Record<string, boolean> => {
      const { [id]: _omit, ...rest } = prev;
      return rest;
    })()));

  const toggle: ToggleFn = useCallback(async (id: string, targetAtivo: boolean) => {
    setLoading(id, true);
    try {
      if (targetAtivo) {
        return await activateUsuario(id);
      }
      return await deactivateUsuario(id);
    } catch (e: any) {
      const msg = e?.message || 'Falha ao atualizar usu??rio.';
      dispatchGlobalError(msg);
      throw e;
    } finally {
      setLoading(id, false);
    }
  }, []);

  const isLoading = useCallback((id: string) => Boolean(loadingById[id]), [loadingById]);

  return { toggle, isLoading } as const;
}

export default useToggleUsuarioAtivo;


